module.exports = __webpack_public_path__ + "img/cloth_g3_hat-06.ff501b9e.svg";